import React from "react";
import Loader from "../Display/Loader";
import Stack from "@mui/material/Stack";
import { useQuery } from "@tanstack/react-query";
import EmomExerciseChart from "./EmomExerciseChart";
import { getEmomDetails } from "../../api/workouts";

const DemandingExerciseChart = ({ workoutId }) => {
  const { data, isPending } = useQuery({
    queryKey: ["workout", workoutId, "emom", "details"],
    queryFn: ({ signal }) => getEmomDetails({ workoutId, signal }),
  });
  return (
    <Stack height={"100%"}>
      {!isPending ? (
        <EmomExerciseChart data={data.success} type={"success"} />
      ) : (
        <Loader height={"100%"} />
      )}
    </Stack>
  );
};

export default DemandingExerciseChart;
